import axios from "axios";
import { RecordsListItem } from "fe-shared/src/types/common";
import { TransferInfoResponse } from "../../../types";

declare module "axios" {
  export interface AxiosRequestConfig {
    hideToast?: boolean;
    errorMessage?: string;
  }
}

export interface AddNoteParams {
  text: string;
  transferId: number;
}
export interface CancelParams {
  isWriteOff: boolean;
  transferNumber: string;
}

export interface InvalidateParams {
  invalidationReason: string;
  isShowToParticipant: boolean;
  transferNumber: string;
}

export const addTransferNote = ({ text, transferId }: AddNoteParams) =>
  axios
    .post(
      "transfers/notes",
      { text },
      { params: { transferId }, hideToast: true }
    )
    .then((res) => res.data);

export const getTransferNotes = (
  transferId: number
): Promise<RecordsListItem[]> =>
  axios
    .get("transfers/notes", {
      params: { transferId },
    })
    .then((res) => res.data);

export const getTransferInfo = (queryKey: string, transferNumber: string) =>
  axios
    .get<TransferInfoResponse>("transfers", {
      params: { transferNumber },
    })
    .then(({ data }) => ({
      ...data.transfer,
      materialPhotos: data.transfer.materialPhotos.map(
        (path) => `${axios.defaults.baseURL}${path}`
      ),
      paperFormImages: data.transfer.paperFormImages?.map(
        (path) => `${axios.defaults.baseURL}${path}`
      ),
    }));

export const cancelTransfer = ({
  isWriteOff,
  transferNumber,
}: CancelParams): Promise<any> =>
  axios
    .post(`transfers/cancel${isWriteOff ? "WriteOff" : ""}`, { transferNumber })
    .then((res) => res.data);

export const invalidateTransfer = ({
  invalidationReason,
  isShowToParticipant,
  transferNumber,
}: InvalidateParams): Promise<any> =>
  axios
    .post("transfers/invalidate", {
      transferNumber,
      invalidationInfo: {
        reason: invalidationReason,
        showToParticipant: isShowToParticipant,
      },
    })
    .then((res) => res.data);
